import { AlignH } from '@repo/ui/src/types';

export const textAlignClasses: Record<AlignH, string> = {
  center: 'tw-text-center',
  inherit: 'tw-text-inherit',
  justify: 'tw-text-justify',
  left: 'tw-text-left',
  right: 'tw-text-right',
};

export const headingClasses = {
  h1: 'tra-text-web-heading-1',
  h2: 'tra-text-web-heading-2',
  h3: 'tra-text-web-heading-3',
  h4: 'tra-text-web-heading-4',
  h5: 'tra-text-web-heading-5',
  h6: 'tra-text-web-heading-6',
  h7: 'tra-text-web-heading-7',
};

export const displayClasses = {
  h1: 'tra-text-web-display-1',
  h2: 'tra-text-web-display-2',
  h1Light: 'tra-text-web-display-1-l',
  h2Light: 'tra-text-web-display-2-l',
};

export type DisplayClassKeys = keyof typeof displayClasses;
export type HeadingClassKeys = keyof typeof headingClasses;
